<template>
  <svg class="icon-loading" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <clipPath id="clip">
      <path
        fill="#000"
        d="M14 5.25C9.16751 5.25 5.25 9.16751 5.25 14C5.25 18.8325 9.16751 22.75 14 22.75C18.8325 22.75 22.75 18.8325 22.75 14C22.75 13.0335 23.5335 12.25 24.5 12.25C25.4665 12.25 26.25 13.0335 26.25 14C26.25 20.7655 20.7655 26.25 14 26.25C7.23451 26.25 1.75 20.7655 1.75 14C1.75 7.23451 7.23451 1.75 14 1.75C14.9665 1.75 15.75 2.5335 15.75 3.5C15.75 4.4665 14.9665 5.25 14 5.25Z"
      />
    </clipPath>
    <foreignObject x="0" y="0" width="28" height="28" clip-path="url(#clip)">
      <div xmlns="http://www.w3.org/1999/xhtml" class="icon-loading__stroke-gradient" />
    </foreignObject>
  </svg>
</template>

<style scoped lang="stylus">
.icon-loading
  animation rotate 0.7s linear infinite

  &__stroke-gradient
    width 100%
    height 100%
    background conic-gradient(
      rgba(0, 0, 0, 1) 10deg,
      rgba(0, 0, 0, 0) 10deg,
      rgba(0, 0, 0, 0) 90deg,
      rgba(0, 0, 0, 1) 360deg
    )
    border-radius: 50%

@keyframes rotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
